<template>
  <div>
    <el-card shadow="always">
      <edit-form
        ref="editForm"
        :disabled="isDisableEditForm"
        :shipmentCode="params.code"
      />
      <ShipmentBatchDetail
        :shipmentCode="params.code"
        ref="shipmentPlanConfirm"
        :disabled="isDisableEditForm"
      />

      <div class="d-flex justify-content-end mb-2 mt-2">
        <el-button
          v-if="!isDisableEditForm"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import ShipmentBatchDetail from '@/views/factory/transport/components/shipment-detail/components/shipment-batch/index.vue'
export default {
  name: 'order-shipmentPlanConfirm-detail',
  components: {
    EditForm,
    ShipmentBatchDetail,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
